// File Metadata:
// Filename: CrewTable.js
// Version: 1.00
// Created: 2025-03-30 15:30:13
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { 
    Paper, Table, TableBody, TableCell, TableContainer, 
    TableHead, TableRow, Chip, IconButton 
} from '@mui/material'
import { AccessTime, Delete as DeleteIcon } from '@mui/icons-material'
import PropTypes from 'prop-types'

const CrewTable = ({ crews, onDelete }) => {
    const handleDelete = (crewId) => {
        if (window.confirm('Are you sure you want to delete this crew?')) {
            onDelete(crewId)
        }
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Schedule</TableCell>
                        <TableCell>Members</TableCell>
                        <TableCell align="right">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {crews.map(crew => (
                        <TableRow key={crew.crewId}>
                            <TableCell>{crew.crewId}</TableCell>
                            <TableCell>{crew.name}</TableCell>
                            <TableCell>{crew.type}</TableCell>
                            <TableCell>
                                <Chip 
                                    icon={<AccessTime />}
                                    label={crew.schedule.type === 'fixed' 
                                        ? `${crew.schedule.fixed.hours.start}-${crew.schedule.fixed.hours.end}`
                                        : 'Alternating'
                                    }
                                    color="primary"
                                    size="small"
                                />
                            </TableCell>
                            <TableCell>{crew.members?.length || 0}</TableCell>
                            <TableCell align="right">
                                <IconButton 
                                    color="error" 
                                    onClick={() => handleDelete(crew.id)}
                                    size="small"
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

CrewTable.propTypes = {
    crews: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired
}

export default CrewTable
